module.exports = __webpack_public_path__ + "static/img/fourteen.0847ef8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expert/fourteen.png
// module id = epbO
// module chunks = 0